import styled from '@emotion/styled'
import { KeyValPair } from '@models/common.model'
import { Box, Checkbox, MenuItem, Select, TextField, Typography } from '@mui/material'
import { Control, Controller, FieldValues } from 'react-hook-form'

const LabelNameBox = styled(Box)(() => ({
	display: 'flex',
	width: '30%',
}))

export const FormSelect = (props: {
	name: string
	control: Control<any>
	label: string | JSX.Element
	options: KeyValPair[]
	defaultValue?: KeyValPair
	isOperatorField?: boolean
}) => {
	return (
		<Controller
			name={props.name}
			control={props.control}
			defaultValue={props.defaultValue}
			render={({ field: { onChange, value }, formState: { defaultValues } }) => (
				<Box
					sx={{
						flexDirection: 'row',
						display: 'flex',
						width: '100%',
						alignItems: 'flex-end',
						height: '40px',
						marginRight: '30px',
						marginBottom: '10px',
					}}
				>
					{props.isOperatorField ? null : (
						<LabelNameBox>
							<Typography variant="h4" color="info">
								{props.label} :{' '}
							</Typography>
						</LabelNameBox>
					)}
					<Select
						onChange={onChange}
						value={value}
						variant="standard"
						sx={{ width: '80%' }}
						defaultValue={defaultValues}
					>
						{props.options?.map((option) => {
							return (
								<MenuItem key={option.key} value={option.key}>
									{option.value}
								</MenuItem>
							)
						})}
					</Select>
				</Box>
			)}
		/>
	)
}
